import { Spinner } from '@frontend/components/common';
import { ICONS } from '@frontend/icons';
import { CommonMessage } from '@frontend/lang';
import { User } from '@frontend/user/utils';
import { LuCheck, LuNfc } from 'react-icons/lu';
import { FormattedMessage } from 'react-intl';

import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import useIdentifyUser from './identify-user.controller';

const ID = 'identify-user';

const IdentifyUser = () => {
    const viewProps = useIdentifyUser();
    const identifiedUserName = viewProps.userOverwrite ? new User(viewProps.userOverwrite).getDisplayName() : null;

    return (
        <WizardScreenContainer
            id={ID}
            footer={{
                onSubmit: viewProps.handleSubmit,
                submitDisabled: viewProps.submitDisabled
            }}
            loadingModal={{ show: viewProps.resolving }}
            errorModal={{
                show: !!viewProps.error,
                title: CommonMessage.ERRORS.UNRECOGNIZED_CODE,
                message: viewProps.error,
                onClose: viewProps.resetError
            }}
            containerClassName='bg-background-default flex flex-1 flex-col items-center justify-start gap-8 self-stretch overflow-y-scroll p-6 pb-20'>
            <div className='inline-flex items-center justify-center gap-3 self-stretch'>
                <div className='relative size-6 overflow-hidden'>
                    <LuNfc className='text-always-black size-6' />
                </div>
                <div className='text-always-black justify-end text-lg font-medium'>
                    <FormattedMessage
                        id='kiosk.wizard.identify-user.scan-badge'
                        defaultMessage='Scan badge'
                        description='Label for badge scanning on identify user screen'
                    />
                </div>
            </div>

            <div className='h-8 w-full' />

            <div className='flex flex-col items-center gap-5'>
                <div className='text-always-black justify-end text-center text-base font-medium'>
                    {viewProps.userOverwrite ? (
                        <span>
                            <FormattedMessage
                                id='kiosk.wizard.identify-user.identified-user-title'
                                defaultMessage='Identified user'
                                description='Title above identified user details on identify-user screen'
                            />
                            <span className='font-semibold'>{identifiedUserName && `: ${identifiedUserName}`}</span>
                        </span>
                    ) : (
                        <FormattedMessage
                            id='kiosk.wizard.identify-user.instructions'
                            defaultMessage='If you are doing this for someone else, please have them scan their badge to identify themselves.'
                            description='Instructions for identifying user by scanning a badge'
                        />
                    )}
                </div>

                <div
                    className={`${viewProps.userOverwrite ? 'bg-status-success' : 'bg-brand-secondary'} flex size-24 items-center justify-center rounded-full`}>
                    {viewProps.userOverwrite ? (
                        <LuCheck className='text-always-white size-16' />
                    ) : (
                        <>
                            {viewProps.resolving && <Spinner className='text-border-default fill-brand-primary size-25' />}
                            <ICONS.BUTTON.ARROW_DOWN className='text-always-white absolute size-10' />
                        </>
                    )}
                </div>
            </div>
        </WizardScreenContainer>
    );
};

export default IdentifyUser;
